// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1RoleScopeSchema = z.object({
  name: z.coerce.string().describe("Internal identifier for the scope (e.g., hide_hourly_rate)"),
  display_name: z.coerce.string().describe("Human-readable name for the scope"),
  description: z.coerce.string().describe("Explanation of what the scope controls"),
  default: z.boolean().describe("Default value for this scope when creating users"),
  options: z.array(z.boolean()).describe("Available values for this scope (e.g., [true, false] or [false])"),
});
